import { ReadonlyVec2 } from 'gl-matrix';
import { gl } from '../../../Engine';
import { Uniform } from './Uniform';

export enum UniformVec2Type {
    FLOAT,
    INTEGER,
}

export class UniformVec2 extends Uniform {
    private type: UniformVec2Type;

    constructor(name: string, type: UniformVec2Type = UniformVec2Type.FLOAT) {
        super(name);
        this.type = type;
    }

    public loadVec2(
        vector: Array<number> | { x: number; y: number } | ReadonlyVec2
    ): void;

    public loadVec2(x: number, y: number): void;

    public loadVec2(
        vector:
            | Array<number>
            | { x: number; y: number }
            | ReadonlyVec2
            | number,
        y?: number
    ) {
        if (this.location) {
            if (this.type === UniformVec2Type.INTEGER) {
                if (vector instanceof Array) {
                    gl.uniform2iv(this.location, vector);
                } else if (typeof vector === 'number') {
                    gl.uniform2i(this.location, vector, y as number);
                } else {
                    gl.uniform2i(
                        this.location,
                        (vector as ReadonlyVec2)[0],
                        (vector as ReadonlyVec2)[1]
                    );
                }
            } else {
                if (vector instanceof Array) {
                    gl.uniform2fv(this.location, vector);
                } else if (typeof vector === 'number') {
                    gl.uniform2f(this.location, vector, y as number);
                } else {
                    gl.uniform2f(
                        this.location,
                        (vector as ReadonlyVec2)[0],
                        (vector as ReadonlyVec2)[1]
                    );
                }
            }
        }
    }
}
